import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Typography } from '../components';
import SignIn from './SignIn';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#EBF6FF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
    minHeight: '100vh',
    transition: 'background-size .3s',
    transitionTimingFunction: 'ease-in'
  },
  background: {
    height: 'auto',
    maxWidth: '50%',
    position: 'absolute'
  },
  logoContainer: {
    display: 'flex'
  },
  logo: {
    maxWidth: 200,
    height: 'auto'
  },
  paper: {
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 90px)'
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '300px'
    },
    padding: '20px',
    borderRadius: 16,
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 10px 0 #0058a166'
  }
}));

const Login = () => {
  const classes = useStyles();
  const app = useSelector(state => state.app);

  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        <img
          alt="Hospital Logo"
          src={app.env.logoUri}
          className={classes.logo}
        />
      </div>
      <Typography type='bold' style={{ textAlign: 'center' }}>
        {app.env.projectId === 'atmost-tangerang' ? 'SIPOPI ADMIN RSUD KABUPATEN TANGERANG' : `Admin Atmost ${app.env.hospitalName}`}
      </Typography>
      <Paper className={classes.paper}>
        <SignIn />
      </Paper>
    </div>
  );
}

export default Login;
